
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'


export default {
components: {
XHeader,
Group,
CellBox,
Cell,
Scroller
},
data() {
return {
title: '使用说明',
list: [{ title: '什么是数字货币策略' }, { title: '什么是数字货币策略2' }]
}
}
}



// WEBPACK FOOTER //
// ./src/components/usercenter/Intro.vue